import { capitalize, startCase } from 'lodash'
import accounting from 'accounting'

export default {
  install (Vue) {
    Vue.filter('nullable', (value, text = '–') => {
      return (value === null || value === undefined || value === '') ? text : value
    })

    Vue.filter('capitalise', function (value) {
      return capitalize(value)
    })

    Vue.filter('startCase', function (value) {
      return startCase(value)
    })

    Vue.filter('money', value => {
      return isNaN(value) || !value ? accounting.formatMoney(0) : accounting.formatMoney(value)
    })
  }
}
